export default __webpack_public_path__ + "static/media/bootstrap.c35a27da.svg";